<template>
  <b-col class="py-3 d-flex flex-column align-items-center">
    <h4 class="h4"><strong>میزبانی ویژه</strong></h4>

    <p class="text-muted my-5">این یک متن تست میباشد</p>

    <m-a :href="{name:'Home'}">
      <Bt1 class="btn-danger text-dark">متن تستی</Bt1>
    </m-a>


  </b-col>
</template>

<script>
import Bt1 from "../Buttons/Bt1.vue";

export default {
  name: "S8",
  components: {Bt1},
};
</script>

<style scoped>
</style>